import css from './css.module.less';
import React from 'react';
import Element from 'src/layout/EditorPageLayout/Element/Elements';

const BasicLayout = (props) => {
  const { header, left, right } = props;
  return (
    <React.Fragment>
      <div className={css.titleContainer}>{header}</div>
      <div className={css.wrapper}>
        <div className={css.contentContainer}>
          <div className={css.leftContainer}>{left}</div>
          <div className={css.rightContainer}>{right}</div>
        </div>
      </div>
    </React.Fragment>
  );
};
const WithElement = (props) => {
  const { leftPart, leftElements, rightPart, rightElements, header } = props;
  const left =
    leftPart ||
    (leftElements || []).map((i, index) => {
      return (
        <Element key={index} style={i.style}>
          {i.child}
        </Element>
      );
    });
  const right =
    rightPart ||
    (rightElements || []).map((i, index) => {
      return (
        <Element key={index} style={i.style}>
          {i.child}
        </Element>
      );
    });
  return <BasicLayout left={left} right={right} header={header} />;
};
export default WithElement;
